export const COMMENT_STATUS = {
  PENDING: "pending",
  FAILURE: "failure",
  SUCCESS: "success",
};



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentsList/components/Comment/constants.js